import * as React from "react";

interface IntegerProps {
    className?: string;
    placeholder?: string;
    disabled?: boolean;
    value?: number;
    onChange?: (value: number) => void;
    onBlur?: () => void;
}

interface IntegerState {
    caret: number;
    value: string;
}

export default class IntegerCtl extends React.PureComponent<IntegerProps, IntegerState> {
    constructor(props: IntegerProps) {
        super(props);
        this.state = { caret: 0, value: this.formatInteger(this.props.value ?? 0) };
    }

    _inputRef = React.createRef<HTMLInputElement>();

    onChange = (e: React.ChangeEvent<HTMLInputElement>) => {

        // Get the changed value and insert a caret indicator
        let caret = e.currentTarget.selectionStart ?? 0;
        let value = e.currentTarget.value.substring(0, caret) + "^" + e.currentTarget.value.substring(caret);

        // Remove the placeholder leading zero if we added the first digit
        if (/^0$/.test(this.state.value) && /^\d\^0$/.test(value))
            value = value.substr(0, 2);

        let int = this.getIntegerPart(value);
        if (int === "^") int = "^0";

        value = `${this.formatDigitGroups(int)}`;

        this.props.onChange?.(parseInt(int.replace(/[,^]/, "")));

	    // Position the caret after the last decimal point if multiple decimal groups 
        caret = value.indexOf("^");
        value = value.replace("^", "");

        if (this.state.caret === caret && this.state.value === value)
            this.forceUpdate(); // We force the update so the caret position gets set
        else
            this.setState({ caret: caret, value: value });
    }

    getIntegerPart(value: string): string {
        // Remove invalid characters, split into integer and decimal parts, remove leading zeros, and drop the decimal part
        const parts: string[] = value.replace(/[^0-9.^]/g, "").split(".");
	    const int = (parts[0] || "0").substr((parts[0] || "0").split("").findIndex((d: string) => d !== "0"));
        return int;
    }

    formatDigitGroups(value: string): string {
        let d = 0;
        for (var i = value.length - 1; i >= 0; i--) {
            if (/[0-9]/.test(value[i])) d++;
            if (d === 3 && i > 0) {
                value = value.substr(0, i) + "," + value.substr(i);
                d = 0;
            }
        }
        return value;
    }

    formatInteger(value: number): string {
        const int = this.getIntegerPart(value.toFixed(0));
	    return this.formatDigitGroups(int);
    }

    componentDidUpdate() {
        const inp: HTMLInputElement | null = this._inputRef.current;
        if (inp) 
            inp.setSelectionRange(this.state.caret, this.state.caret);
    }

    render() {
        return <input ref={this._inputRef}
                      type="text"
                      className={this.props.className + (this.props.disabled ? " disabled" : "")}
                      value={this.formatInteger(this.props.value ?? 0)}
                      placeholder={this.props.placeholder}
                      onChange={this.onChange}
                      onBlur={this.props.onBlur}
                      disabled={this.props.disabled}/>;
    }
}